import { render, staticRenderFns } from "./CourierServicechargeDetails.vue?vue&type=template&id=1ef74108&"
import script from "./CourierServicechargeDetails.vue?vue&type=script&lang=js&"
export * from "./CourierServicechargeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports